import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=5c937a98"
import script from "./CommentList.vue?vue&type=script&lang=ts"
export * from "./CommentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports